module.exports = __webpack_public_path__ + "img/RPL.6f9b6403.jpg";